import { Modal } from "react-bootstrap";
import { Button } from "../../components/button";
import { GenericForm } from "../../components/generic-form";

import { CreateBasketModalProps } from "./Basket.types";

const CreateBasketModal = ({
  isVisible,
  onDismiss,
  onSubmit,
  creating,
  createBasketForm,
}: CreateBasketModalProps) => {
  return (
    <Modal show={isVisible} animation onHide={onDismiss}>
      <Modal.Header>
        <h5 className="modal-title" id="Dismiss Modal">
          Create Basket
        </h5>
        <div onClick={onDismiss}>
          <span className="font-20 cursor-pointer">&times;</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <GenericForm
          form={createBasketForm}
          onSubmit={onSubmit}
          submitControl={(submit) => (
            <div className="flex-row">
              <Button
                isLoading={creating}
                loader={{ size: "s" }}
                className="btn btn-primary mt-3 w-100"
                type="submit"
              >
                Create
              </Button>
            </div>
          )}
        />
      </Modal.Body>
    </Modal>
  );
};

export default CreateBasketModal;
